module.exports = __webpack_public_path__ + "static/media/gb.7afb0e69.svg";